<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-starred-folder`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.342 8c.647 0 1.261.312 1.676.85L21.44 12h22.464c1.157 0 2.095.895 2.095 2v28c0 1.105-.938 2-2.095 2H4.095C2.938 44 2 43.105 2 42V10.364C2 9.058 2.977 8 4.182 8h13.16zM42 16H6v24h36V16zm-17.726 5.077c.083.05.152.123.2.21l1.941 3.524a.55.55 0 00.36.274l3.792.85a.575.575 0 01.42.681.584.584 0 01-.127.265l-2.593 3.027a.593.593 0 00-.137.444l.399 4.014a.568.568 0 01-.488.63.525.525 0 01-.294-.053l-3.51-1.773a.524.524 0 00-.474 0l-3.51 1.773a.536.536 0 01-.73-.268.598.598 0 01-.052-.309l.399-4.014a.593.593 0 00-.137-.444l-2.593-3.027a.595.595 0 01.041-.811.539.539 0 01.252-.135l3.792-.85a.55.55 0 00.36-.274l1.941-3.524a.533.533 0 01.748-.21z"/></svg>
</template>
<script>

export default {
  name: 'IconStarredFolder',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
